import Link from 'next/link';
import { Layout, CtaForm } from '../../components';
import { place_desks, set_permissions, book_desk } from '../../utils/images';

export default function Hotdesks() {
	return (
		<Layout pageName="HotDesks">
			{/* Use building-type class because this page is same layout with BuildingType page */}
			<div className="building-type">
				<section className="heading-container">
					<div className="container">
						<div className="heading">
							<h1 className="heading__title">Hotdesks</h1>
							<h2 className="heading__desc">
								FacilityBot is here to support workplaces shifting towards hybrid work arrangements. Our Hotdesks
								feature allow building occupants to easily select zones, view floorplans and book hotdesks, through
								their preferred messaging platform.
							</h2>
						</div>
					</div>
				</section>

				<section className="building-type__articles">
					<div className="container">
						<div className="building-type__articles-wrapper">
							<article className="building-type__article">
								<div className="building-type__article-content">
									<h3 className="building-type__article-title">Create Zones, Upload Floor Plans, Place Desks</h3>
									<div className="building-type__article-desc">
										Easily create multiple work zones and upload floor plans for each Zone. Place desks on each floor
										plan.{' '}
									</div>
								</div>

								<img
									src={place_desks}
									alt=""
									className="building-type__article-img building-type__article-img--unset-order"
								/>
							</article>
							<article className="building-type__article">
								<div className="building-type__article-content">
									<h3 className="building-type__article-title">Manage Desks Booking Permissions</h3>
									<div className="building-type__article-desc">
										Requestors can be tagged and each Requestor tag assigned permissions to book desks in specified
										Zones.
									</div>
								</div>

								<img
									src={set_permissions}
									alt=""
									className="building-type__article-img building-type__article-img--unset-order"
								/>
							</article>
							<article className="building-type__article">
								<div className="building-type__article-content">
									<h3 className="building-type__article-title">Book through your preferred Messaging App</h3>
									<div className="building-type__article-desc">
										FacilityBot supports booking through WhatsApp, Telegram, Facebook Messenger, Facebook Workplace,
										Google Chat and Line
									</div>
								</div>

								<img
									src={book_desk}
									alt=""
									className="building-type__article-img building-type__article-img--unset-order"
								/>
							</article>
						</div>
					</div>
				</section>

				<div className="pricing-wrapper">
					<div className="container">
						<h2 className="pricing-wrapper__title">
							The Hotdesks Feature is available with Professional and Plus plans
						</h2>

						<button className="btn btn--plans">
							<Link href="/pricing-plans">view plans and pricing</Link>
						</button>
					</div>
				</div>

				<CtaForm />
			</div>
		</Layout>
	);
}
